// import image from '../images/logo.png';

import { useEffect, useState } from "react";
import bot from '../images/happy.png'
import Frame1 from "./Frame1";

function Greetings(){
    const [time] = useState(new Date());


    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
      };
      const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data
    setTimeout(() => setLoading(false), 1000); 
  }, []);
    return(
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1 animated-frame">
            {getGreeting()}, Greetings from Akaay Dairy<br/>
            </div>
        <div className="frame1">
                      {/* <img src={image} className="IMAGE" alt="img" /> */}
                     
                     Welcome to Dodla Dairy  — The Most Loved Dairy Brand! We are delighted to have you here. 
                      
                    </div>
                    <Frame1 />
                    {/* <Mainmenu /> */}
                    </>
    );
}

export default Greetings;